import { NoddiAsyncError } from 'noddi-types';
import { hasErrorCode } from 'noddi-util';

export const isOutsideServiceAreaError = (error: NoddiAsyncError | (NoddiAsyncError | null)[] | null | undefined) => {
  if (!error) {
    return false;
  }
  return (
    hasErrorCode(error, 'service_department_not_found_api_error') ||
    hasErrorCode(error, 'address_not_close_to_service_department')
  );
};
